import {
	useQuery,
	useInfiniteQuery,
	useQueryClient,
	useMutation,
} from "react-query";
import { toast } from "react-toastify";
import API from "./utils/api";
import {
	AllowanceGroupDto,
	AllowanceGroupPaginator,
	CreateAllowanceGroupDto,
	QueryAllowanceGroupDto,
	SearchAllowanceGroupDto,
	UpdateAllowanceGroupDto,
} from "../models/allowance-group.dto";
import ENDPOINTS from "./utils/endpoints";
import { QueryOptionsDto } from "../models/generic.dto";

export function useGetAllowanceGroup(
	companyId: number,
	options?: QueryAllowanceGroupDto,
) {
	const url = ENDPOINTS.PROCESSING_COMPANY.ALLOWANCEGROUP.GET;
	const request = (options: QueryAllowanceGroupDto) =>
		API.ProcessingCompanyAPI.getAllowanceGroups(companyId, options);

	const { data, isLoading, error, refetch } = useQuery<
		AllowanceGroupPaginator,
		Error
	>(
		[url, options],
		({ queryKey, pageParam }) =>
			request(Object.assign({}, queryKey[1], pageParam)),
		{ ...API.Handlers.pageParamOption },
	);

	return { data, isLoading, error, refetch };
}

export function useGetAllowanceGroupSearch(companyId: number) {
	return useMutation(
		(options?: SearchAllowanceGroupDto) =>
			API.ProcessingCompanyAPI.getAllowanceGroupSearch(companyId, options),
		{
			onSuccess: () => {
				//toast.success('Record created successfully');
			},
			onError: API.Handlers.onErrorHandler,
		},
	);
}

export function useGetAllowanceGroupById(companyId: number, id: number) {
	const url = ENDPOINTS.PROCESSING_COMPANY.ALLOWANCEGROUP.DETAIL;
	const request = API.ProcessingCompanyAPI.getAllowanceGroupById(companyId, id);

	const { data, isLoading, error } = useQuery<
		{ data: AllowanceGroupDto },
		Error
	>([url, id], () => request, {
		enabled: !!id,
	});

	return {
		data: data,
		isLoading,
		error,
	};
}
export function useCreateAllowanceGroup() {
	const queryClient = useQueryClient();

	return useMutation(
		({
			companyId,
			payload,
		}: {
			companyId: number;
			payload: CreateAllowanceGroupDto;
		}) => API.ProcessingCompanyAPI.createAllowanceGroup(companyId, payload),
		{
			onSuccess: () => {
				toast.success("Record created successfully");
				queryClient.invalidateQueries(
					ENDPOINTS.PROCESSING_COMPANY.ALLOWANCEGROUP.GET,
				);
			},
			onError: API.Handlers.onErrorHandler,
		},
	);
}

export function useUpdateAllowanceGroup() {
	const queryClient = useQueryClient();

	return useMutation(
		({
			payload,
			companyId,
			id,
		}: {
			payload: UpdateAllowanceGroupDto;
			companyId: number;
			id: number;
		}) => API.ProcessingCompanyAPI.updateAllowanceGroup(companyId, id, payload),
		{
			onSuccess: () => {
				toast.success("Record updated successfully");
				queryClient.invalidateQueries(
					ENDPOINTS.PROCESSING_COMPANY.ALLOWANCEGROUP.GET,
				);
			},
			onError: API.Handlers.onErrorHandler,
		},
	);
}

export function useDeleteAllowanceGroup() {
	return useMutation(
		({ companyId, id }: { companyId: number; id: number }) =>
			API.ProcessingCompanyAPI.deleteAllowanceGroupById(companyId, id),
		{
			onSuccess: () => {
				toast.success("Record deleted successfully");
			},
			onError: API.Handlers.onErrorHandler,
		},
	);
}
